"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.customDataValidator = void 0;

var validators_1 = require("./validators");

var customDataV1Scheme = {
  version: validators_1.isEq(1),
  binary: validators_1.isBase64
};
var customDataV2Scheme = {
  version: validators_1.isEq(2),
  data: validators_1.validatePipe(validators_1.isArray, function (data) {
    return data.every(validators_1.validatePipe(validators_1.isRequired(true), validators_1.isValidDataPair));
  })
};
var v1Validator = validators_1.validateByShema(customDataV1Scheme, validators_1.getError);
var v2Validator = validators_1.validateByShema(customDataV2Scheme, validators_1.getError);
exports.customDataValidator = validators_1.ifElse(validators_1.pipe(validators_1.prop('version'), validators_1.isEq(1)), v1Validator, v2Validator);